import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

const baseStyle = defineStyle({
  border: '1px',
  opacity: 1,
});

export default defineStyleConfig({
  baseStyle,
});
